let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("WLxru")).then(() => parcelRequire('l3IeQ'));